import axios from "axios";

    


const cPost = 'Njl_GiG/P9t-BCT'
const cGet = 'eQR_FrR/YlO-E5M'
const cPut = '6Kh_vFb/ZHB-YmU'
const cDel = '2il_aOf/Ago-2Z4'

export default {

    login(user, headers){
        return axios.post(`/${cPost}/login`, user, headers);
    },

    getInfoUser(data, headers){
      return axios.post(`/${cPost}/info_usr`, data, {headers});
    },
    
  getAllInfo(option, headers){
    return axios.get(`/${cGet}/${option}`, {headers});
  },

  getStatusImage(payload, headers){
    return axios.get(`/${cGet}/${payload.option}-img/${payload.image}`, {headers});
  },
  
  getInfoById(payload, headers){
    return axios.get(`/${cGet}/${payload.option}/${payload.id}`, {headers});
  },
 
  search(data, headers){
    return axios.get(`/${cGet}/buscar/${data.normalizedOpt}/${data.search}`, {headers});
  },

  searchById(data, headers){
    return axios.get(`/${cGet}/buscar/${data.normalizedOpt}/${data.id}/${data.search}`, {headers});
  },

  enviarVacantes(data, headers){
    return axios.post('j43-wdrDE4s_wffs2/vacantes', data, headers);
  },
 
  enviarMailContacto(data, headers){
    return axios.post('j43-wdrDE4s_wffs2/contacto', data, headers);
  },
  enviarMailBuzon(data, headers){
    return axios.post('j43-wdrDE4s_wffs2/buzon', data, headers);
  },
  //metodos de eliminar, editar y agregar
  deleteItem(payload,token){
    return axios.delete(`/${cDel}/${payload.option}/delete`, {
        data: {
          id:payload.id
        },
        headers: {
          Authorization: token 
        } 
      });
  },
  
  editItem(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.put(`/${cPut}/${payload.option}/update`, payload.item, {headers} );
  },

  addItem(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.post(`/${cPost}/${payload.option}/create`, payload.item, {headers});
  },

  editImage(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.put(`/${cPut}/${payload.option}/upload/image/${payload.id}`, payload.item, {headers} );
  },


}